import React from 'lib/react';
import {
  EVGrid, EVPaper, EVTypography, EVIconButton, EVNoteIcon, EVContactMailOutlinedIcon,
  EVShoppingCartOutlinedIcon, EVReportProblemOutlined, EVPaymentOutlinedIcon, EVReportsCheckIcon,
} from 'lib/components';
import { useTranslation } from 'lib/translation';
import {
  ORDER_HISTORY_ROUTE, CONTACT_INFORMATION_ROUTE, ORDER_PREFERENCES_ROUTE, BILLING_INFORMATION_ROUTE, MANAGE_PAYMENT_OPTIONS_ROUTE,
  TEXT_ALERT_SETTINGS_ROUTE,
} from 'constants/RouteConstants';
import { Link } from 'lib/router';
import history from 'store/CreateHistory';
import { useSelector } from 'lib/redux';
import { isOrderingDisabledSelector } from 'utils/appSelectors.utils';
import QuickLinksStyles from './QuickLinksStyles';

function QuickLinks() {
  const { t } = useTranslation();
  const classes = QuickLinksStyles();
  const {
    currencyTypeId,
  } = useSelector(({ userData }) => ({
    // #genai: use optional chaining (Sonar S6582); userData.initParameters is either an object or null/undefined, so semantics are unchanged
    currencyTypeId: userData.initParameters?.currencyTypeId,
  }));
  const isOrderingDisabled = useSelector(isOrderingDisabledSelector);
  return (
    <EVPaper id="quick-links" className={classes.quickLinksPaper}>
      <EVGrid className={classes.headerBox}>
        <EVTypography className={classes.headerText}>{t('dashboard__quick_links')}</EVTypography>
      </EVGrid>
      <EVGrid className={classes.contentBox}>
        <EVGrid className={classes.element}>
          <EVIconButton onClick={() => history.push(ORDER_HISTORY_ROUTE)} className={classes.iconButton} id="reports-orderHistory">
            <EVReportsCheckIcon style={{ marginLeft: '10px' }} />
          </EVIconButton>
          <Link className={classes.contentText} to={ORDER_HISTORY_ROUTE}>{t('dashboard__reports_and_order_history')}</Link>
        </EVGrid>
        {!isOrderingDisabled && (
        <>
          <EVGrid className={classes.element}>
            <EVIconButton onClick={() => history.push(BILLING_INFORMATION_ROUTE)} className={classes.iconButton} id="billingIformation">
              <EVNoteIcon htmlColor="#82899C" />
            </EVIconButton>
            <Link className={classes.contentText} to={BILLING_INFORMATION_ROUTE}>{t('dashboard__billing_information')}</Link>
          </EVGrid>
          <EVGrid className={classes.element}>
            <EVIconButton onClick={() => history.push(ORDER_PREFERENCES_ROUTE)} className={classes.iconButton} id="orderPreferences">
              <EVShoppingCartOutlinedIcon htmlColor="#82899C" />
            </EVIconButton>
            <Link className={classes.contentText} to={ORDER_PREFERENCES_ROUTE}>{t('dashboard__order_preferences')}</Link>
          </EVGrid>
        </>
        )}
        <EVGrid className={classes.element}>
          <EVIconButton onClick={() => history.push(CONTACT_INFORMATION_ROUTE)} className={classes.iconButton} id="contactInformation">
            <EVContactMailOutlinedIcon htmlColor="#82899C" />
          </EVIconButton>
          <Link className={classes.contentText} to={CONTACT_INFORMATION_ROUTE}>{t('dashboard__contact_information')}</Link>
        </EVGrid>
        <EVGrid className={classes.element}>
          <EVIconButton onClick={() => history.push(TEXT_ALERT_SETTINGS_ROUTE)} className={classes.iconButton} id="textAlert">
            <EVReportProblemOutlined htmlColor="#82899C" />
          </EVIconButton>
          <Link className={classes.contentText} to={TEXT_ALERT_SETTINGS_ROUTE}>{t('dashboard__text_alert_settings')}</Link>
        </EVGrid>
        {currencyTypeId !== 4 && !isOrderingDisabled && (
        <EVGrid className={classes.element}>
          <EVIconButton onClick={() => history.push(MANAGE_PAYMENT_OPTIONS_ROUTE)} className={classes.iconButton} id="payment-membership">
            <EVPaymentOutlinedIcon htmlColor="#82899C" />
          </EVIconButton>
          <Link className={classes.contentText} to={MANAGE_PAYMENT_OPTIONS_ROUTE}>{t('dashboard__payment_options_and_membership_levels')}</Link>
        </EVGrid>
        )}
      </EVGrid>
    </EVPaper>
  );
}

export default QuickLinks;
